import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { SelectorListItem } from './zf-selector-list-type';

@Component({
  selector: 'zf-selector-list',
  templateUrl: 'zf-selector-list.html',
  styleUrls: ['zf-selector-list.scss'],
})
export class ZFSelectorList implements OnChanges {
  @Input() items!: SelectorListItem[][];
  @Input() header!: string;
  @Input() headerClasses!: string[];
  @Input() activeIndex!: number;

  @Input() listClasses!: string[];

  @Output() onElementSelect = new EventEmitter();

  public currentActiveIndex = 0;

  public changeActiveIndex(index: number) {
    this.activeIndex = index;
    this.onElementSelect.emit(index);
  }

  public closeList() {
    this.onElementSelect.emit(null);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeIndex) {
      this.currentActiveIndex = this.activeIndex;
    }
  }
}
